import { ProblemNotice } from "@quovy/ui";
import { Button } from "@quovy/ui/button";
import { Input } from "@quovy/ui/input";
import { useState, type FormEvent } from "react";

import { ApiError, portal, startPortalSignIn, type PortalMe } from "../lib/api";

export function SignIn({ onSignedIn }: { onSignedIn: (session: PortalMe) => void }) {
  const [email, setEmail] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const localSignIn = import.meta.env.DEV;

  const submitLocal = async (event: FormEvent) => {
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      onSignedIn(
        await portal.devLogin({
          email: email.trim(),
          ...(organizationName.trim() ? { organization_name: organizationName.trim() } : {}),
        }),
      );
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : String(cause));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="portal-signin">
      <div className="portal-signin-lede">
        <span className="cp-eyebrow">Customer portal</span>
        <h1>Sign in</h1>
      </div>
      <div className="portal-signin-panel">
        <Button onClick={startPortalSignIn}>Continue with Quovy</Button>
        {localSignIn ? (
          <form className="grid gap-3" onSubmit={(event) => void submitLocal(event)}>
            <div className="grid gap-2">
              <label htmlFor="portal-dev-email" className="text-sm font-medium">
                Local email
              </label>
              <Input
                id="portal-dev-email"
                type="email"
                required
                autoComplete="username"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
            <div className="grid gap-2">
              <label htmlFor="portal-dev-org" className="text-sm font-medium">
                Organization name
              </label>
              <Input
                id="portal-dev-org"
                value={organizationName}
                autoComplete="organization"
                onChange={(event) => setOrganizationName(event.target.value)}
              />
            </div>
            <Button type="submit" variant="outline" disabled={busy || email.trim().length === 0}>
              {busy ? "Signing in…" : "Sign in locally"}
            </Button>
          </form>
        ) : null}
        {error ? (
          <ProblemNotice
            title="Sign-in did not complete"
            howToResolve="Correct the email, or use Continue with Quovy, then retry."
            resolution={{ kind: "in-place" }}
            live
          >
            {error}
          </ProblemNotice>
        ) : null}
      </div>
    </main>
  );
}
